/* Snaplates custom sections behaviour */
(function () {
  function initDemos(root) {
    (root || document).querySelectorAll('[data-sn-stage]').forEach(function (stage) {
      if (stage.dataset.snInit) return;
      stage.dataset.snInit = '1';
      var panel = stage.closest('.demo-panel');
      var insert = stage.querySelector('[data-sn-insert]');
      var swapBtns = panel.querySelectorAll('.swap-btn');
      swapBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          swapBtns.forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          var type = btn.getAttribute('data-insert');
          insert.className = 'insert ' + type;
          insert.textContent = type === 'l' ? 'L' : 'P';
        });
      });
      panel.querySelectorAll('[data-sn-mode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-sn-mode');
          stage.classList.toggle('day', mode === 'day');
          panel.querySelectorAll('[data-sn-mode]').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
        });
      });
    });
  }
  function initStickybar() {
    var bar = document.querySelector('.snap .stickybar');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = document.querySelector('.snap .hero') || document.querySelector('.snap .page-hero');
    var finalEl = document.querySelector('.snap .final');
    var shopEl = document.querySelector('.snap .products-sec');
    if (!hero) return;
    var heroOut = false, finIn = false, shopIn = false;
    function upd() { bar.classList.toggle('show', heroOut && !finIn && !shopIn); }
    new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; upd(); }).observe(hero);
    if (finalEl) new IntersectionObserver(function (e) { finIn = e[0].isIntersecting; upd(); }).observe(finalEl);
    if (shopEl) new IntersectionObserver(function (e) { shopIn = e[0].isIntersecting; upd(); }, { threshold: .15 }).observe(shopEl);
  }
  function init() { initDemos(document); initStickybar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { initDemos(e.target); });
})();
